// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';

export default class CurrencyConversionRatePage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicCurrencyConversionRates';
        this.Server =
            this.props.context.getState().server.publicCurrencyConversionRates;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['currencyFrom', 'currencyTo'];
        this.hasCustomLogicOnMount = true;
        const defaultHead = [
            {
                id: 'currencyFrom',
                label: 'currencyFrom',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'currencyTo',
                label: 'currencyTo',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'rate',
                label: 'rate',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'active',
                label: 'active',
                alignRight: false,
                cell: 'Checkbox',
                type: 'boolean',
                // displayGrid: true
                disableEditor: true,
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated',
            },
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
    customLogicOnMount() {
        this.fs.clearGroup('prefilterBase')
            .addFilter('active', '!=', false, 'prefilterBase', true);
    }
}
